// extracted by mini-css-extract-plugin
export default {"header":"_2gc4orGssMqzhZqvWCJW-"};